import { createContext, useContext } from "react";

/**
 * Context for the `assistant-console` feature flag value. The provider
 * (`AssistantAccessProvider.tsx`) resolves the flag once at the top of the
 * route tree and broadcasts the boolean here; consumers read it via
 * `useAssistantAccess()`. Context + reader hook live together (separate from
 * the provider) so each module exports one kind of thing — the React Fast
 * Refresh requirement the core app follows for its scheduling-access split.
 */
export const AssistantAccessContext = createContext<boolean | null>(null);

/**
 * Read the `assistant-console` flag from the provider context. Falls back to
 * `false` when no provider is mounted (or while the flag is still loading) so
 * a forgotten provider can never accidentally expose the Assistant section —
 * matching the flag's default-off behavior.
 */
export function useAssistantAccess(): boolean {
  return useContext(AssistantAccessContext) ?? false;
}
